import { axiosInstance } from "../axios";
import { withParams } from "./discounts";


export const getNotifications = (params) => {
    return axiosInstance
        .get(withParams('notifications/', params))
        .then(({ data }) => data.results);
};